<app-map [layers]="layers" [interactive]="false" />
@if (navigateToMaps && device && device.longitude && device.latitude) {
  <button
    class="maps-button button outlined-button icon-button"
    (click)="onOpenInMaps(device.latitude, device.longitude)"
  >
    {{ "devices.detail.goToMaps" | translate }}
    <app-icon name="ic_chevron_right" />
  </button>
}
